// The 8 sports SportsMeld supports. `id` is the API `sport` value;
// `label` is the human-readable name shown in the UI.

export interface Sport {
  id: string
  label: string
}

export const SPORTS: Sport[] = [
  { id: 'soccer', label: 'Soccer' },
  { id: 'basketball', label: 'Basketball' },
  { id: 'tennis', label: 'Tennis' },
  { id: 'american_football', label: 'American Football' },
  { id: 'volleyball', label: 'Volleyball' },
  { id: 'ice_hockey', label: 'Ice Hockey' },
  { id: 'baseball', label: 'Baseball' },
  { id: 'rugby', label: 'Rugby' },
]

export function sportLabel(id: string): string {
  return SPORTS.find((s) => s.id === id)?.label ?? id
}
